import Dexie from 'dexie';
import type { Table } from 'dexie';
import type { LogEntry, OutboxRow } from './types';

class LoggingDatabase extends Dexie {
    logs!: Table<LogEntry, number>;
    outbox!: Table<OutboxRow, number>;

    constructor() {
        super("clientLoggingDb");

        this.version(1).stores({
            logs: "++id, timestamp, level, category, event, sessionId"
        })

        // Retention on logs must never delete an undelivered record.
        this.version(2).stores({
            logs: "++id, timestamp, level, category, event, sessionId",
            outbox: "++id, &uuid, state, level"
        })
    }
}

export const loggingDb = new LoggingDatabase();
